import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconColumns = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M1.66663 9.16667C1.66663 6.02397 1.66663 4.45262 2.64294 3.47631C3.61925 2.5 5.1906 2.5 8.33329 2.5H11.6666C14.8093 2.5 16.3807 2.5 17.357 3.47631C18.3333 4.45262 18.3333 6.02397 18.3333 9.16667V10.8333C18.3333 13.976 18.3333 15.5474 17.357 16.5237C16.3807 17.5 14.8093 17.5 11.6666 17.5H8.33329C5.1906 17.5 3.61925 17.5 2.64294 16.5237C1.66663 15.5474 1.66663 13.976 1.66663 10.8333V9.16667Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
    />
    <path
      d="M13.3334 17.5L13.3334 7.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M6.66663 17.5L6.66663 7.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <line
      x1="1.66663"
      y1="6.75"
      x2="18.3333"
      y2="6.75"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
    />
  </SvgIcon>
)
